import { PropsWithChildren } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

/**
 * Wraps page content with a subtle fade-in transition on mobile.
 * Uses the route pathname as the animation key so content fades
 * when navigating between pages.
 */
const MobilePageTransition = function ({ children }: PropsWithChildren): JSX.Element {
  const { pathname } = useLocation();

  // Use only the first two path segments as key to avoid re-animating
  // on sub-path changes (e.g., tabs within a page).
  const segments = pathname.split('/').filter(Boolean);
  const animationKey = segments.slice(0, 2).join('/');

  return (
    <motion.div
      key={animationKey}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: [0.2, 0.8, 0.4, 1] }}
      style={{ flex: 1, minHeight: 0 }}
    >
      {children}
    </motion.div>
  );
};

export default MobilePageTransition;
